exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Manager-___table__table___2PaOi .ant-table{border:none}.src-components-Manager-___table__table___2PaOi .ant-dropdown-link{font-size:1.35em}.src-components-Manager-___table__upgrade___DvCDy{background:rgba(0,0,0,0.05);line-height:1.3}\n", ""]);

// Exports
exports.locals = {
	"table": "src-components-Manager-___table__table___2PaOi",
	"upgrade": "src-components-Manager-___table__upgrade___DvCDy"
};